const C = {
  name: "CzechRepublic",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 10V16H7V10H9Z" fill="currentColor"/>
<path d="M13 16H11V10H13V16Z" fill="currentColor"/>
<path d="M2 2H18V6H18.9999C20.6521 6 21.9999 7.34772 21.9999 9V13C21.9999 15.6352 19.9633 17.793 17.3776 17.986C17.135 18.7932 16.823 19.5801 16.4444 20.3372C15.9365 21.353 14.9021 22 13.76 22H6.24C5.09791 22 4.06348 21.353 3.55557 20.3372C2.53665 18.2994 2 16.0464 2 13.76V2ZM17.8457 15.8792C19.0912 15.5143 19.9999 14.3639 19.9999 13V9C19.9999 8.45228 19.5476 8 18.9999 8H18V13.76C18 14.4715 17.948 15.1797 17.8457 15.8792ZM4 4V6H16V4H4ZM4 13.76C4 15.7336 4.46335 17.6806 5.34443 19.4428C5.51652 19.787 5.86209 20 6.24 20H13.76C14.1379 20 14.4835 19.787 14.6556 19.4428C15.5367 17.6806 16 15.7336 16 13.76V8H4V13.76Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as CzechRepublic
};
